import { useNotificationsContext } from "common/context/NotificationsProvider"
import { Button } from "primereact/button"
import { useTranslation } from "react-i18next"
import "../style.scss"

const NotificationsGetMoreButton = () => {
  const { t } = useTranslation()
  // @ts-expect-error TS(2339): Property 'allNotifications' does not exist on type...
  const { allNotifications, setNotificationsQueryState } =
    useNotificationsContext()
  const { queryState, totalCount } = allNotifications
  const hasMore = allNotifications.list.length < totalCount

  const getMoreNotifications = () => {
    setNotificationsQueryState({
      ...queryState,
      skipCount: queryState.skipCount + queryState.maxResultCount,
    })
  }

  return (
    <>
      {hasMore && (
        <div className='pb-3 d-flex justify-content-center w-100'>
          <Button
            className='p-0 p-button-text notifications-actions'
            onClick={getMoreNotifications}
            disabled={!hasMore}
          >
            {t("notifications.getMore.text")}
          </Button>
        </div>
      )}
    </>
  )
}

export default NotificationsGetMoreButton
